import format from 'date-fns/format'
import isProd from 'utils/isProd'

const addTimestamp = () => `[${format(new Date(), 'HH:mm:ss.SSS')}] -`

const isLogEnabled = () => isProd()

const warn = (message: string | Event) => {
  if (isLogEnabled()) return

  const isString = typeof message === 'string'

  if (isString) {
    // eslint-disable-next-line no-console
    console.warn(addTimestamp(), message)
  } else {
    // eslint-disable-next-line no-console
    console.warn(message)
  }
}

const info = (message: string | Event) => {
  if (isLogEnabled()) return

  const isString = typeof message === 'string'

  if (isString) {
    console.info(addTimestamp(), message) // eslint-disable-line no-console
  } else {
    console.info(message) // eslint-disable-line no-console
  }
}

export default { info, warn }
